module.exports = __webpack_public_path__ + "img/75.2c9ad616.jpg";